import XLSX from 'xlsx'
import { EmployeeReport } from 'models'
import moment from 'moment'
import { millisecondsToDuration } from 'functions/helpers'
import { reportStatuses } from 'models'

export const downloadExcel = ({ employeeReports }: { employeeReports: EmployeeReport[] }) => {
  const msecsInHour = 60*60*1000
  let reportData: Array<object> = []
  employeeReports.forEach((item) => {
    reportData.push({
      ID: item.id,
      Päivämäärä: moment(item.start_time_iso_date).toDate(),
      Viikko: moment(item.start_time_iso_date).week(),
      Aloitusaika: moment(item.start_time_iso_date).format('HH:mm'),
      Lopetusaika: moment(item.end_time_iso_date).format('HH:mm'),
      Työaika: millisecondsToDuration(item.data.total_work_time), // '3h30min'
      'Työtunnit(h)': Number((item.data.total_work_time/(msecsInHour)).toFixed(2)), // '3.5'
      Asiakas: item.meta?.customer.name,
      Toimeksianto: item.meta?.customer.assignment?.name,
      Työntekijä: item.meta?.employee.last_name + ' ' + item.meta?.employee.first_name,
      Tila: reportStatuses.find((status) => status.key === item.status)?.value,
      'Ruokatauko(min)': item.data.lunch_break_duration,
      Päiväraha: item.data.daily_allowance ? 'Kyllä' : 'Ei',
      Ateriatuki: item.data.lunch_support ? 'Kyllä' : 'Ei',
      'Kilometrikorvaus(km)': item.data.driving_kilometers,
      Lisätiedot: item.data.additional_details
    })
  })
  const ws = XLSX.utils.json_to_sheet(reportData)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Työtunnit')
  XLSX.writeFile(wb, `${moment().format('YYYYMMDD HHmm')} Aputeam Export.xlsx`)
}
